/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GegEvaluationRequestPost } from '../../models/geg-evaluation-request-post';
import { GegEvaluationResponse } from '../../models/geg-evaluation-response';

export interface CalculationsControllerGegEvaluation$Params {
      body: GegEvaluationRequestPost
}

export function calculationsControllerGegEvaluation(http: HttpClient, rootUrl: string, params: CalculationsControllerGegEvaluation$Params, context?: HttpContext): Observable<StrictHttpResponse<GegEvaluationResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerGegEvaluation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GegEvaluationResponse>;
    })
  );
}

calculationsControllerGegEvaluation.PATH = '/planning-projects/v1/calculations/geg-evaluation';
